import React, { FunctionComponent } from "react";
import variables from "@episerver/design-tokens/dist/json/variables";
import { DesignTokenColor } from "./design-token-color";

interface ColorSwatchProps {
    name: string;
}

export const ColorSwatch: FunctionComponent<ColorSwatchProps> = ({ name }: ColorSwatchProps) => {
    const variableName = `color-${name.toLocaleLowerCase()}`;

    const color = variables.find(color => color.name === variableName);

    if (!color) {
        // console.error should stop the gatsby build.
        console.error(`color-swatch Error: Color name ${name} not found. Are you sure it exists in the design-tokens?`); // eslint-disable-line no-console
        return <code>Color {name} not found</code>;
    }

    // Prefix the hex code with '#' to make it easier to use. Need to be a copy as writing to the object is persisted through renders and module loads.
    const colorValue = `#${color.hex}`;

    return <DesignTokenColor name={color.name} color={colorValue} />;
};
